import ProductPageContent from "components/ProductPageContent";
import { PRODUCT_PAGES } from "data/productPages";

function SandstonePage() {
  return <ProductPageContent data={PRODUCT_PAGES["sandstone"]} />;
}

export default SandstonePage;
